<div class="progress-bar">
    <div 
        class="outer-bar" 
        #outerRef
    ></div>
    <div 
        class="inner-bar" 
        [class.completed]="completed"
        #innerRef
    ></div>
    <div 
        class="module-label {{labelToggle ? 'showNg' : 'hideNg'}}"
        #labelRef
    >
        <span>{{this.label}}</span>
    </div>
</div>